import { useMemo } from 'react';

import cardTypeCheckers from 'types/cardTypeCheckers';

import { ContentInput } from './useContentMetricIds';

const useContentVisDefinitionIds = ({
  content,
  contentType,
}: ContentInput): {
  dashboardGadgetIds: string[];
  reportGadgetIds: string[];
} => {
  return useMemo(() => {
    const dashboardGadgetIds: string[] = [];
    const reportGadgetIds: string[] = [];

    if (contentType === 'Dashboard' || contentType === 'Report') {
      content.canvas.cards.forEach((card) => {
        if (cardTypeCheckers.isDashboardGadget(card)) {
          dashboardGadgetIds.push(card.content.dashboardGadgetId);
        } else if (cardTypeCheckers.isReportGadget(card)) {
          reportGadgetIds.push(card.content.reportGadgetId);
        }
      });
    }

    const uniqueReportGadgetIds = [...new Set(reportGadgetIds)];
    return {
      dashboardGadgetIds: [...new Set(dashboardGadgetIds)],
      reportGadgetIds: uniqueReportGadgetIds,
    };
  }, [content, contentType]);
};

export default useContentVisDefinitionIds;
